import styled from "styled-components";
import {theme} from "../../styles/theme";

export const ContainerGeral = styled.div`
    width: 100%;
    height: auto;

    >div>form{
        >div{
            >div>div{
                    >label{
                        padding: 0 4px;

                        opacity: 1;
                        border-radius: 4px !important;
                        background-color: white !important;
                    }
                    
                    >input{
                        font-weight: ${theme.typography.fontWeight.regular} !important;

                        cursor: not-allowed;
                        border-radius: 8px !important;
                        color: ${theme.colors.disabled.Desabilitado_Medio} !important;
                        border: 1px solid ${theme.colors.disabled.Desabilitado_Medio} !important;
                        background-color: ${theme.colors.disabled.Fundo_Desabilitado} !important;
                    }
                }

             >input{
                    font-weight: ${theme.typography.fontWeight.regular} !important;
                   
                    border-radius: 8px !important;
                }
        }
        
        >div:last-child {
            div>button{
                    font-weight: ${theme.typography.fontWeight.extraBold} !important;
                }
        }
    }
`